export default "__VITE_ASSET__ddb01812__"